export const useNativeConfirm = () => {
	return confirm;
};
